import React, { useState } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { getUserData } from 'utils';
import { createAPIEndPoint } from 'config/api/api';
import toast from 'react-hot-toast';

const StatusModal = ({ isOpen, onClose, type = 'add', endpoint = 'lab', fetchLab,
  fetchBatch,
  fetchPreAuth }) => {
  const userData = getUserData();
  console.log("StatusModal ~ endpoint:", endpoint)
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    statusName: Yup.string().required('Status Name is required'),
  });

  const formik = useFormik({
    initialValues: {
      statusName: '',

    },
    validationSchema,
    onSubmit: (values) => {
      handleAddStatus(values, { resetForm: formik.resetForm });
    },
  });


  const handleAddStatus = async (values, { resetForm }) => {
    console.log("Runninfs");

    try {
      setLoading(true);

      // Prepare the payload
      const payload = {
        status_name: values.statusName,
        status: 'active',  // Setting the status to 'active' as per your requirement
        user_id: 1,
        // user_id: userData?.id ?? 1,

      };
      console.log("handleAddStatus ~ payload:", payload)

      // Send the API request based on the endpoint
      const api = await createAPIEndPoint(
        `${endpoint === "lab" ? "lab_case_status" : endpoint === "pre-auth" ? "pre_auth_status" : "batch_case_status"}`
      ).create(payload);
      // Assuming create() sends the payload

      if (endpoint === "lab") {
        fetchLab();
      } else if (endpoint === "pre-auth") {
        fetchPreAuth();
      } else {
        fetchBatch();
      }
      toast.success('Status added successfully!');
      setLoading(false);
      resetForm();
      onClose();
    } catch (error) {
      setLoading(false);
      console.error('Error adding status:', error);
      const errorMessage =
        error.response?.data?.error ||
        'An error occurred while adding the status.';
      toast.error(errorMessage);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        borderRadius="16px"
        pb="16px"
        maxWidth={{ base: '90%', md: '448px' }}
        maxH="90vh"
        overflowY="auto"
      >
        <ModalHeader color="brand.500">
          {endpoint === "lab" ?
            "Add New Lab Status" : endpoint === "pre-auth" ? "Add New Pre Auth Status" : "Add New Batch Status"
          }
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <form onSubmit={formik.handleSubmit}>
            {[
              'statusName',
            ].map((field, index) => (
              <FormControl
                key={index}
                isInvalid={formik.touched[field] && formik.errors[field]}
                mb={2}
              >
                <FormLabel mb={0} textTransform="capitalize">
                  {field.replace(/([A-Z])/g, ' $1').trim()}
                </FormLabel>
                <Input
                  name={field}
                  placeholder={`Enter ${field
                    .replace(/([A-Z])/g, ' $1').trim().toLowerCase()}`}
                  variant="auth"
                  fontSize="sm"
                  fontWeight="500"
                  value={formik.values[field]}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched[field] && formik.errors[field] && (
                  <Text color="red.500" fontSize="sm">
                    {formik.errors[field]}
                  </Text>
                )}
              </FormControl>
            ))}
            <Button type="submit" colorScheme="brand" w="100%" mt={4} isLoading={loading}>
              Add Status
            </Button>
          </form>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default StatusModal;
